function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.212 2.75A2.75 2.75 0 013.962 0h.512v1.5h-.512c-.69 0-1.25.56-1.25 1.25v2.24c0 .78-.33 1.502-.874 2.01a2.75 2.75 0 01.874 2.01v2.24c0 .69.56 1.25 1.25 1.25h.512V14h-.512a2.75 2.75 0 01-2.75-2.75V9.01a1.25 1.25 0 00-.908-1.202l-.306-.087V6.28l.306-.087a1.25 1.25 0 00.908-1.203V2.75zm7.034 3.5v-2.5h1.5v2.5h2.516v1.5H9.746v2.5h-1.5v-2.5H5.73v-1.5h2.516zM14.03 0a2.75 2.75 0 012.75 2.75v2.24c0 .558.371 1.049.909 1.202l.305.087V7.72l-.305.087a1.25 1.25 0 00-.909 1.203v2.239A2.75 2.75 0 0114.03 14h-.512v-1.5h.512c.69 0 1.25-.56 1.25-1.25V9.01c0-.78.33-1.502.874-2.01a2.749 2.749 0 01-.873-2.01V2.75c0-.69-.56-1.25-1.25-1.25h-.513V0h.512z",
  clipRule: "evenodd"
});

var SvgBrackets = function SvgBrackets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 14",
    fill: "#D6D7E1"
  }, props), _ref);
};

export default SvgBrackets;